import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { STORAGE_KEY_ACTIVE_CHAT } from '../../../const';
import storageService from '../../../service/StorageService';
import { getUser, getUserLoadingState, toggleAuthModal, updateUser } from '../../../store/slices/authSlice';
import AutocompliteInput from '../../common/AutocompliteInput';
import CustomButton from '../../common/Button';
import DateTimePicker from '../../common/DateTimePicker';
import ClockCalendarIcon from '../../icons/ClockCalendarIcon';
import styles from './styles.module.scss';

const SecondAuthStep = () => {
    const userData = useSelector(getUser);
    const dispatch = useDispatch();
    const loading = useSelector(getUserLoadingState);
    const activeChatId = storageService.get(STORAGE_KEY_ACTIVE_CHAT);
    const { t } = useTranslation();

    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        setValue
    } = useForm();

    const onSubmit = (data) => {
        if (loading) {
            return;
        }
        dispatch(
            updateUser({
                birthDate: data.birthDate,
                birthAddress: { placeId: data.birthAddress?.value, description: data.birthAddress?.label },
                ...(!!activeChatId && { chatId: activeChatId.toString() })
            })
        ).then(() => {
            dispatch(toggleAuthModal({ trigger: false }));
        });
    };

    return (
        <>
            <h2 className={classNames(styles.title, styles.nameTitle)}>Hi, {userData?.name}!</h2>
            <p className={styles.subtitle}>{t('modal.authSecondTitle')}</p>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={styles.inputWrapper}>
                    <div className={styles.datePicker}>
                        <DateTimePicker
                            defaultValue={userData?.birthDate}
                            showTimePicker={false}
                            control={control}
                            placeholder={t('placeholders.birthTime')}
                            name="birthDate"
                            setValue={setValue}
                            customInput={<input className={styles.input} id={'birthDate'} type="text" readOnly />}
                        />
                        <ClockCalendarIcon />
                    </div>
                    {errors.birthDate ? (
                        <span className={styles.error}>{errors.birthDate.message}</span>
                    ) : (
                        <span className={styles.optional}>{t('modal.label4')}</span>
                    )}
                </div>
                <div className={styles.inputWrapper}>
                    <AutocompliteInput
                        defaultValue={userData?.birthAddress}
                        register={register}
                        control={control}
                        name={'birthAddress'}
                        setValue={setValue}
                    />
                    {errors.birthAddress ? (
                        <span className={styles.error}>{errors.birthAddress.message}</span>
                    ) : (
                        <span className={styles.optional}>{t('labels.determine')}</span>
                    )}
                </div>
                <CustomButton text={t('buttons.submit')} loading={loading} disable={loading} fontKhand={true} />
            </form>
        </>
    );
};

export default SecondAuthStep;
